import { Injectable, OnDestroy } from '@angular/core';
import { HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { tap } from "rxjs/operators";
//import { CookieService } from 'angular2-cookie/core';
import { Auth } from '../../_import/auth';
import { HttpOptions } from '../../_models/http-options';
import { environment } from 'src/environments/environment';
import { CommonService } from '../common.service';

const LOGIN_PATH = '/auth/login';
const LOGOUT_PATH = '/auth/logout';

@Injectable({
  providedIn: 'root'
})
export class BffAuthService extends Auth implements OnDestroy {

  protected authenticated = false;
  protected httpOptions: HttpOptions | undefined;
  authSubs: Subscription = new Subscription;

  constructor(private router: Router,
    private commonService: CommonService
  ) {
    super();
  }

  public isAuthenticated(): boolean {
    //this.authenticated = !!this.cookieService.get('authN') && this.cookieService.get('authN') == 'true';
    return this.authenticated;
  }

  public async loginWithRedirect(): Promise<void> {
    this.authSubs = this.login().subscribe(response => {
      window.location.href = response.authorization_request_url;
    });
  }

  private login(): Observable<any> {
    let headers = { headers: {  'Accept-Version': 'V2' } }
    return this.commonService.postCall(this.getUrlPrefix() + environment.API_BASE_PATH + LOGIN_PATH, {} , headers).pipe(
      tap(() => {
      })
    );
  }

  public handleRedirectCallback(): void {
    this.authenticated = true;
  }

  public async logoutWithRedirect(returnUrl: string): Promise<void> {
    this.authSubs = this.logout().subscribe(response => {
      this.authenticated = false;
      this.router.navigate([returnUrl]);
    });
  }

  private logout(): Observable<any> {
    return this.commonService.postCall(this.getUrlPrefix() + environment.API_BASE_PATH + LOGOUT_PATH, {}).pipe(
      tap(() => {
      })
    );
  }

  public getCurrentUser(): any {
    return {
      id: '',
      sub: '',
      username: 'rob.ferguson',
      name: 'Rob Ferguson',
      givenName: 'Rob',
      middleName: '',
      familyName: 'Ferguson',
      email: '',
      emailVerified: '',
      groups: ''
    };
  }

  // Need to confirm whether it's used ?
  private getHttpOptions(params: any = undefined): HttpOptions {
    if (!this.httpOptions) {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        observe: 'response',
        params: undefined
      };
    }

    params ? this.httpOptions.params = params : null;

    return this.httpOptions;
  }

  private getUrlPrefix(): string {
    return window.location.hostname.includes('localhost') ? ('http' + '://' + environment.DOMAIN_NAME + '/') : window.location.href;

    //Commented for TEDWR-874 ticket
    // let localURL = 'http' + '://' + environment.DOMAIN_NAME + '/';
    // let redirectURL = (window.location.href.includes('login?logout=')) ? window.location.origin : window.location.href;
    // return window.location.hostname.includes('localhost') ? localURL : redirectURL;
  }

  getLoginScreenDetails(): Observable<any> {
    let headers = { headers: {'Accept-Version': 'V2' } }
    return this.commonService.getCall(`${environment.API_BASE_PATH}/tenant/landing-page`, headers);
  }

  ngOnDestroy() {
    this.authSubs && this.authSubs.unsubscribe();
  }

}
